var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-column justify-center"},[_c('div',{staticClass:"flex justify-center w-100 h-100 pt3"},[_c('img',{staticClass:"slideInfoImg",attrs:{"src":_vm.img}})]),_vm._v(" "),_c('div',{staticClass:"ph3 self-center"},[_c('p',{staticClass:"tc silver"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-075dcc00","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/subscription/SlideInfo.vue
// module id = 822
// module chunks = 4